import { defineStore } from "pinia";

const units = [
  {
    id: 1,
    unitCode: "A-101",
    houseNo: "88/101",
    building: "อาคาร A",
    zone: "โซนหน้า",
    unitType: "condo",
    area: 35,
    residentName: "สมชาย ใจดี",
    occupancyStatus: "occupied",
    paymentStatus: "paid",
    monthlyFee: 1800,
    balance: 0,
    lastPaymentDate: "2026-03-29",
    ownerName: "สมชาย ใจดี",
    phone: "081-234-5678",
    email: "somchai@example.com",
    moveInDate: "2025-06-15",
    parkingSlots: 1,
    note: "ชำระตรงเวลาอย่างสม่ำเสมอ",
  },
  {
    id: 2,
    unitCode: "A-102",
    houseNo: "88/102",
    building: "อาคาร A",
    zone: "โซนหน้า",
    unitType: "condo",
    area: 35,
    residentName: "สุดา รุ่งเรือง",
    occupancyStatus: "occupied",
    paymentStatus: "partial",
    monthlyFee: 1800,
    balance: 900,
    lastPaymentDate: "2026-03-18",
    ownerName: "สุดา รุ่งเรือง",
    phone: "082-345-6789",
    email: "suda@example.com",
    moveInDate: "2025-09-01",
    parkingSlots: 1,
    note: "มีคำขอผ่อนชำระบางส่วน",
  },
  {
    id: 3,
    unitCode: "B-203",
    houseNo: "88/203",
    building: "อาคาร B",
    zone: "โซนกลาง",
    unitType: "condo",
    area: 48,
    residentName: "นที วรากร",
    occupancyStatus: "occupied",
    paymentStatus: "overdue",
    monthlyFee: 2500,
    balance: 3200,
    lastPaymentDate: "2026-02-05",
    ownerName: "นที วรากร",
    phone: "089-111-2233",
    email: "natee@example.com",
    moveInDate: "2024-11-20",
    parkingSlots: 1,
    note: "ติดตามค้างชำระรอบล่าสุดแล้ว",
  },
  {
    id: 4,
    unitCode: "C-305",
    houseNo: "88/305",
    building: "อาคาร C",
    zone: "โซนสวน",
    unitType: "condo",
    area: 42,
    residentName: "อรทัย พงศ์พันธ์",
    occupancyStatus: "occupied",
    paymentStatus: "paid",
    monthlyFee: 2200,
    balance: 0,
    lastPaymentDate: "2026-03-27",
    ownerName: "อรทัย พงศ์พันธ์",
    phone: "081-778-9900",
    email: "ornthai@example.com",
    moveInDate: "2025-02-10",
    parkingSlots: 1,
    note: "ต้องการรับเอกสารทางอีเมล",
  },
  {
    id: 5,
    unitCode: "D-110",
    houseNo: "88/110",
    building: "อาคาร D",
    zone: "โซนหน้า",
    unitType: "house",
    area: 56,
    residentName: "ปกรณ์ ศิริชัย",
    occupancyStatus: "occupied",
    paymentStatus: "paid",
    monthlyFee: 2800,
    balance: 0,
    lastPaymentDate: "2026-03-30",
    ownerName: "ปกรณ์ ศิริชัย",
    phone: "086-998-0011",
    email: "pakorn@example.com",
    moveInDate: "2023-08-18",
    parkingSlots: 2,
    note: "บ้านเดี่ยว มุมถนนหลัก",
  },
  {
    id: 6,
    unitCode: "E-402",
    houseNo: "88/402",
    building: "อาคาร E",
    zone: "โซนกลาง",
    unitType: "condo",
    area: 38,
    residentName: "จิราพร บุญมี",
    occupancyStatus: "occupied",
    paymentStatus: "overdue",
    monthlyFee: 1900,
    balance: 2500,
    lastPaymentDate: "2026-02-20",
    ownerName: "จิราพร บุญมี",
    phone: "084-556-7788",
    email: "jiraporn@example.com",
    moveInDate: "2024-05-12",
    parkingSlots: 1,
    note: "เคยแจ้งขอรับแจ้งเตือนทางโทรศัพท์",
  },
  {
    id: 7,
    unitCode: "F-208",
    houseNo: "88/208",
    building: "อาคาร F",
    zone: "โซนสวน",
    unitType: "shop",
    area: 64,
    residentName: "วสันต์ เกียรติยศ",
    occupancyStatus: "occupied",
    paymentStatus: "overdue",
    monthlyFee: 4100,
    balance: 4100,
    lastPaymentDate: "2026-01-28",
    ownerName: "วสันต์ เกียรติยศ",
    phone: "095-002-3344",
    email: "wasan@example.com",
    moveInDate: "2022-12-01",
    parkingSlots: 2,
    note: "ร้านค้าหน้าทางเข้าโครงการ",
  },
  {
    id: 8,
    unitCode: "G-109",
    houseNo: "88/109",
    building: "อาคาร G",
    zone: "โซนหลัง",
    unitType: "house",
    area: 52,
    residentName: "พรทิพย์ สกุลดี",
    occupancyStatus: "occupied",
    paymentStatus: "partial",
    monthlyFee: 2600,
    balance: 1200,
    lastPaymentDate: "2026-03-12",
    ownerName: "พรทิพย์ สกุลดี",
    phone: "087-665-8899",
    email: "porntip@example.com",
    moveInDate: "2024-01-05",
    parkingSlots: 2,
    note: "อยู่ระหว่างผ่อนชำระยอดค้าง",
  },
  {
    id: 9,
    unitCode: "H-501",
    houseNo: "88/501",
    building: "อาคาร H",
    zone: "โซนหลัง",
    unitType: "condo",
    area: 72,
    residentName: "ชัยวัฒน์ ทองสุข",
    occupancyStatus: "occupied",
    paymentStatus: "overdue",
    monthlyFee: 3200,
    balance: 5000,
    lastPaymentDate: "2026-01-15",
    ownerName: "ชัยวัฒน์ ทองสุข",
    phone: "088-345-9001",
    email: "chaiwat@example.com",
    moveInDate: "2023-03-11",
    parkingSlots: 1,
    note: "ยอดค้างสะสมเกิน 60 วัน",
  },
  {
    id: 10,
    unitCode: "I-220",
    houseNo: "88/220",
    building: "อาคาร I",
    zone: "โซนกลาง",
    unitType: "condo",
    area: 31,
    residentName: "",
    occupancyStatus: "vacant",
    paymentStatus: "vacant",
    monthlyFee: 1600,
    balance: 0,
    lastPaymentDate: null,
    ownerName: "-",
    phone: "-",
    email: "-",
    moveInDate: null,
    parkingSlots: 0,
    note: "ยูนิตว่าง รอผู้เข้าพักใหม่",
  },
  {
    id: 11,
    unitCode: "J-120",
    houseNo: "88/120",
    building: "อาคาร J",
    zone: "โซนหน้า",
    unitType: "house",
    area: 58,
    residentName: "กิตติภพ สุขใจ",
    occupancyStatus: "occupied",
    paymentStatus: "paid",
    monthlyFee: 2850,
    balance: 0,
    lastPaymentDate: "2026-03-25",
    ownerName: "กิตติภพ สุขใจ",
    phone: "092-773-6644",
    email: "kittipop@example.com",
    moveInDate: "2025-01-19",
    parkingSlots: 2,
    note: "ชำระล่วงหน้าสม่ำเสมอ",
  },
  {
    id: 12,
    unitCode: "K-310",
    houseNo: "88/310",
    building: "อาคาร K",
    zone: "โซนสวน",
    unitType: "shop",
    area: 70,
    residentName: "",
    occupancyStatus: "vacant",
    paymentStatus: "vacant",
    monthlyFee: 4300,
    balance: 0,
    lastPaymentDate: null,
    ownerName: "-",
    phone: "-",
    email: "-",
    moveInDate: null,
    parkingSlots: 0,
    note: "ร้านค้าว่าง พร้อมให้เช่า",
  },
];

const invoiceHistory = {
  1: [
    {
      id: "INV-2026-0001",
      billingMonth: "มีนาคม 2026",
      amount: 1800,
      dueDate: "2026-03-31",
      status: "paid",
    },
    {
      id: "INV-2026-0035",
      billingMonth: "เมษายน 2026",
      amount: 1800,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
  2: [
    {
      id: "INV-2026-0002",
      billingMonth: "มีนาคม 2026",
      amount: 1800,
      dueDate: "2026-03-31",
      status: "partial",
    },
    {
      id: "INV-2026-0036",
      billingMonth: "เมษายน 2026",
      amount: 1800,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
  3: [
    {
      id: "INV-2026-0003",
      billingMonth: "กุมภาพันธ์ 2026",
      amount: 2500,
      dueDate: "2026-02-29",
      status: "overdue",
    },
    {
      id: "INV-2026-0016",
      billingMonth: "มีนาคม 2026",
      amount: 2500,
      dueDate: "2026-03-31",
      status: "overdue",
    },
    {
      id: "INV-2026-0037",
      billingMonth: "เมษายน 2026",
      amount: 2500,
      dueDate: "2026-04-30",
      status: "pending",
    },
  ],
  7: [
    {
      id: "INV-2026-0008",
      billingMonth: "มกราคม 2026",
      amount: 4100,
      dueDate: "2026-01-31",
      status: "overdue",
    },
    {
      id: "INV-2026-0019",
      billingMonth: "กุมภาพันธ์ 2026",
      amount: 4100,
      dueDate: "2026-02-28",
      status: "overdue",
    },
    {
      id: "INV-2026-0039",
      billingMonth: "มีนาคม 2026",
      amount: 4100,
      dueDate: "2026-03-31",
      status: "pending",
    },
  ],
};

const paymentHistory = {
  1: [
    {
      id: "PAY-2026-0011",
      date: "2026-03-29",
      amount: 1800,
      method: "โอนธนาคาร",
      receiptNo: "RC-2026-0011",
    },
    {
      id: "PAY-2026-0003",
      date: "2026-02-27",
      amount: 1800,
      method: "QR Payment",
      receiptNo: "RC-2026-0003",
    },
  ],
  2: [
    {
      id: "PAY-2026-0014",
      date: "2026-03-18",
      amount: 900,
      method: "เงินสด",
      receiptNo: "RC-2026-0014",
    },
  ],
  3: [
    {
      id: "PAY-2026-0001",
      date: "2026-02-05",
      amount: 1800,
      method: "โอนธนาคาร",
      receiptNo: "RC-2026-0001",
    },
  ],
  7: [
    {
      id: "PAY-2026-0002",
      date: "2026-01-28",
      amount: 4100,
      method: "เงินสด",
      receiptNo: "RC-2026-0002",
    },
  ],
};

export const useUnitStore = defineStore("unit", {
  state: () => ({
    filters: { search: "", unitType: "", paymentStatus: "" },
    units,
    invoiceHistory,
    paymentHistory,
  }),

  getters: {
    filteredUnits: (state) => {
      const keyword = state.filters.search.trim().toLowerCase();
      return state.units.filter((unit) => {
        const matchesSearch =
          !keyword ||
          unit.unitCode.toLowerCase().includes(keyword) ||
          unit.houseNo.toLowerCase().includes(keyword) ||
          unit.building.toLowerCase().includes(keyword) ||
          unit.zone.toLowerCase().includes(keyword) ||
          (unit.residentName || "").toLowerCase().includes(keyword);
        const matchesType =
          !state.filters.unitType || unit.unitType === state.filters.unitType;
        const matchesPaymentStatus =
          !state.filters.paymentStatus ||
          unit.paymentStatus === state.filters.paymentStatus;
        return matchesSearch && matchesType && matchesPaymentStatus;
      });
    },
    totalUnits: (state) => state.units.length,
    occupiedUnits: (state) =>
      state.units.filter((u) => u.occupancyStatus === "occupied").length,
    vacantUnits: (state) =>
      state.units.filter((u) => u.occupancyStatus === "vacant").length,
    overdueUnits: (state) =>
      state.units.filter((u) => u.paymentStatus === "overdue").length,
    expectedMonthlyIncome: (state) =>
      state.units.reduce((sum, u) => sum + u.monthlyFee, 0),
    totalOutstanding: (state) =>
      state.units.reduce((sum, u) => sum + u.balance, 0),
    unitTypeOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "บ้าน", value: "house" },
      { label: "ห้องชุด", value: "condo" },
      { label: "ร้านค้า", value: "shop" },
    ],
    paymentStatusOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "ชำระแล้ว", value: "paid" },
      { label: "ชำระบางส่วน", value: "partial" },
      { label: "ค้างชำระ", value: "overdue" },
      { label: "ว่าง", value: "vacant" },
    ],
    getUnitById: (state) => (id) =>
      state.units.find((u) => u.id === Number(id)) || null,
    getInvoicesByUnitId: (state) => (id) =>
      state.invoiceHistory[Number(id)] || [],
    getPaymentsByUnitId: (state) => (id) =>
      state.paymentHistory[Number(id)] || [],
  },

  actions: {
    setSearch(value) {
      this.filters.search = value;
    },
    setUnitType(value) {
      this.filters.unitType = value;
    },
    setPaymentStatus(value) {
      this.filters.paymentStatus = value;
    },
    resetFilters() {
      this.filters.search = "";
      this.filters.unitType = "";
      this.filters.paymentStatus = "";
    },

    // ✅ เพิ่มยูนิตใหม่
    addUnit(payload) {
      const nextId = this.units.length
        ? Math.max(...this.units.map((u) => u.id)) + 1
        : 1;
      this.units.unshift({
        id: nextId,
        unitCode: payload.unitCode,
        houseNo: payload.houseNo,
        building: payload.building,
        zone: payload.zone || "",
        unitType: payload.unitType,
        area: Number(payload.area) || 0,
        parkingSlots: Number(payload.parkingSlots) || 0,
        monthlyFee: Number(payload.monthlyFee) || 0,
        occupancyStatus: payload.occupancyStatus,
        paymentStatus: "pending",
        residentName: "",
        ownerName: "",
        phone: "",
        email: "",
        moveInDate: null,
        balance: 0,
        lastPaymentDate: null,
        note: payload.note || "",
      });
    },

    // ✅ แก้ไขยูนิต
    updateUnit(payload) {
      const index = this.units.findIndex((u) => u.id === payload.id);
      if (index === -1) return;
      this.units[index] = {
        ...this.units[index],
        unitCode: payload.unitCode,
        houseNo: payload.houseNo,
        building: payload.building,
        zone: payload.zone || "",
        unitType: payload.unitType,
        area: Number(payload.area) || 0,
        parkingSlots: Number(payload.parkingSlots) || 0,
        monthlyFee: Number(payload.monthlyFee) || 0,
        occupancyStatus: payload.occupancyStatus,
        note: payload.note || "",
      };
    },
  },
});
